import React, { useEffect, useState } from "react";
import BodyHeader from "../../../../components/common/CommonBodyHeader";
import CustomInput from "../../../../components/common/CustomInput/CustomInput";
import CustomTable from "../../../../components/common/CustomTable";
import { useNavigate } from "react-router-dom";
import CustomToggleSwitch from "../../../../components/common/CustomToggle";
import { useSelector, useDispatch } from "react-redux";
import { listVendorMasterAsync } from "../../../../redux/features/vendorMaster";
import { backdropLoadingAction } from "../../../../redux/features/helperSlice";
import toast from "react-hot-toast";
import { BsPencilSquare } from "react-icons/bs";
import { changeStatus } from "../../../../Api/dispatch/vendor-dispatch";
import * as XLSX from "xlsx";
import moment from "moment/moment";
import { useBoolean } from "../../../../Hooks/useBoolean";
import DownloadReportButton from "../../../../components/common/DownloadReportButton";
import { vendorMasterReportAsync } from "../../../../redux/features/reportSlice";

export default function VendorMasterList() {
   const navigate = useNavigate();
   const dispatch = useDispatch();

   const [records, setRecords] = useState([]);
   const [isActiveLoading, setIsActiveLoading] = useState({
      id: "",
      status: false,
   });

   const vendorMaster = useSelector((state) => state.vendorMaster);
   const vendorMasterList = vendorMaster?.dataList;

   const reportPopup = useBoolean();

   useEffect(() => {
      dispatch(backdropLoadingAction(true));
      dispatch(
         listVendorMasterAsync({
            done: () => {
               dispatch(backdropLoadingAction(false));
            },
            err: (error) => {
               dispatch(backdropLoadingAction(false));
               toast.error(error);
            },
         })
      );
   }, []);

   useEffect(() => {
      if (vendorMasterList) setRecords(vendorMasterList);
   }, [vendorMasterList]);

   // Handle active inactive
   const handleActiveInactive = (vendor) => {
      setIsActiveLoading({ id: vendor?.id, status: true });
      changeStatus({ id: vendor?.id, status: vendor?.is_active === "1" ? "0" : "1" })
         .then((res) => {
            setIsActiveLoading({ id: vendor?.id, status: false });
            dispatch(listVendorMasterAsync({}));
            toast.success(
               `vendor ${vendor?.is_active === "1" ? "deactivated" : "activated"}`
            );
         })
         .catch((error) => {
            setIsActiveLoading({ id: vendor?.id, status: false });
            toast.error(
               `Failed to ${vendor?.is_active === "1" ? "deactivate" : "activate"} vendor`
            );
         });
   };

   //  Download fleet Report
   const handleDownloadReport = (data) => {
      dispatch(backdropLoadingAction(true));

      dispatch(
         vendorMasterReportAsync({
            data: data,
            err: () => {
               dispatch(backdropLoadingAction(false));
            },
            done: (report) => {
               const headers = [
                  "S. No.",
                  "Vendor Name",
                  "Address (1,2,3… Multiple addition required)",
                  "Vendor Contact Name (1,2,3… Multiple addition required)",
                  "Vendor Contact No. (1,2,3… Multiple addition required)",
                  "Vendor Mail Address (1,2,3… Multiple addition required)",
                  "GST Details",
                  "Vendor Account No.",
                  "Vendor IFSC Code",
                  "Agreement Details",
                  "",
                  "Location (1,2,3… Multiple addition required)",
                  "Lane name (1,2,3… Multiple addition required) (Lane Name = Cust.name#origin#destination#vehicleType#tonnage)",
                  "Origin",
                  "Destination",
                  "Rate",
                  "Express mode rate additional",
                  "Super express mode rate additional",
                  "Multiple loading location rate additional",
                  "Multiple unloading location rate additional",
                  "Detention Charge",
                  "Loading charges",
                  "Unloading charge",
                  "Miscellaneous charges",
                  "Miscellaneous Remarks",
               ];

               const subheaders = [
                  "", // S. No.
                  "", // Vendor Name
                  "", // Address (1,2,3… Multiple addition required)
                  "", // Vendor Contact Name (1,2,3… Multiple addition required)
                  "", // Vendor Contact No. (1,2,3… Multiple addition required)
                  "", // Vendor Mail Address (1,2,3… Multiple addition required)
                  "", // GST Details
                  "", // Vendor Account No.
                  "", // Vendor IFSC Code
                  "Start Date", // Agreement Details (1,2,3… Multiple addition required)
                  "End Date", // Agreement Details (1,2,3… Multiple addition required)
                  "", // Location (1,2,3… Multiple addition required)
                  "", // Lane name (1,2,3… Multiple addition required) (Lane Name = Cust.name#origin#destination#vehicleType#tonnage)
                  "", // Origin
                  "", // Destination
                  "", // Rate
                  "Express Mode", // Express mode rate additional
                  "Super Express Mode", // Super express mode rate additional
                  "", // Multiple loading location rate additional
                  "", // Multiple unloading location rate additional
                  "", // Detention Charge
                  "Loading Charge", // Loading charges
                  "Unloading Charge", // Unloading charge
                  "Miscellaneous Charges", // Miscellaneous charges
                  "", // Miscellaneous Remarks
               ];

               const vendorMasterDataArr = [];
               const adhocVendorMasterDataArr = [];

               let vendorMasterMaxSubArrLength = 0;
               let adhocVendorMasterMaxSubArrLength = 0;
               let vendorMasterId = null;
               let adhocVendorMasterId = null;

               report?.vendorMaster?.forEach?.((item, index) => {
                  vendorMasterMaxSubArrLength = Math.max(
                     item?.contact_personal_details?.length ?? 0,
                     item?.lane?.length ?? 0
                  );

                  for (let i = 0; i < vendorMasterMaxSubArrLength; i++) {
                     const arr = [];
                     arr.push(
                        vendorMasterId === item?.id ? "-" : index + 1,
                        item?.name ?? "-", // Vendor Name
                        item?.address ?? "-", // Address (1,2,3… Multiple addition required)
                        item?.contact_personal_details?.[i]?.name ?? "-", // Vendor Contact Name (1,2,3… Multiple addition required)
                        item?.contact_personal_details?.[i]?.mobile ?? "-", // Vendor Contact No. (1,2,3… Multiple addition required)
                        item?.contact_personal_details?.[i]?.email ?? "-", // Vendor Mail Address (1,2,3… Multiple addition required)
                        item?.gst_number ?? "-", // GST Details
                        item?.account_number ?? "-", // Vendor Account No.
                        item?.ifsc_code ?? "-", // Vendor IFSC Code
                        item?.agreement_start_date ?? "-", // Agreement Details Start Date
                        item?.agreement_end_date ?? "-", // Agreement Details End Date
                        item?.location_master?.name ?? "-", // Location (1,2,3… Multiple addition required)
                        item?.lane?.[i]?.name ?? "-", // Lane name (1,2,3… Multiple addition required) (Lane Name = Cust.name#origin#destination#vehicleType#tonnage)
                        item?.origin ?? "-", // Origin
                        item?.destination ?? "-", // Destination
                        item?.lane?.[i]?.vend_trip_rate ?? "-", // Rate
                        item?.lane?.[i]?.vend_express_mode_rate_additional ?? "-", // Express mode rate additional
                        item?.lane?.[i]?.vend_super_express_mode_rate_additional ?? "-", // Super express mode rate additional
                        item?.lane?.[i]?.vend_multiple_loading_location_rate_additional ??
                           "-", // Multiple loading location rate additional
                        item?.lane?.[i]
                           ?.vend_multiple_unloading_location_rate_additional ?? "-", // Multiple unloading location rate additional
                        item?.lane?.[i]?.vend_detention_rate_additional ?? "-", // Detention Charge
                        item?.lane?.[i]?.vend_loading_charges ?? "-", // Loading charges
                        item?.lane?.[i]?.vend_unloading_charge ?? "-", // Unloading charge
                        item?.lane?.[i]?.vend_miscellaneous_charges ?? "-", // Miscellaneous charges
                        item?.lane?.[i]?.vend_miscellaneous_remarks ?? "-" // Miscellaneous Remarks
                     );
                     vendorMasterId = item?.id;
                     vendorMasterDataArr.push(arr);
                  }
               });

               console.log({ vendorMasterDataArr });

               report?.adhocVendorMaster?.forEach?.((item, index) => {
                  adhocVendorMasterMaxSubArrLength = Math.max(
                     item?.contact_personal_details?.length ?? 0,
                     item?.lanes?.length ?? 0
                  );

                  for (let i = 0; i < adhocVendorMasterMaxSubArrLength; i++) {
                     const arr = [];
                     arr.push(
                        adhocVendorMasterId === item?.id
                           ? "-"
                           : report?.vendorMaster?.length + index + 1,
                        item?.name ?? "-", // Vendor Name
                        item?.address ?? "-", // Address (1,2,3… Multiple addition required)
                        item?.contact_personal_details?.[i]?.name ?? "-", // Vendor Contact Name (1,2,3… Multiple addition required)
                        item?.contact_personal_details?.[i]?.mobile ?? "-", // Vendor Contact No. (1,2,3… Multiple addition required)
                        item?.contact_personal_details?.[i]?.email ?? "-", // Vendor Mail Address (1,2,3… Multiple addition required)
                        item?.gst_number ?? "-", // GST Details
                        item?.account_number ?? "-", // Vendor Account No.
                        item?.ifsc_code ?? "-", // Vendor IFSC Code
                        item?.agreement_start_date ?? "-", // Agreement Details Start Date
                        item?.agreement_end_date ?? "-", // Agreement Details End Date
                        item?.location_master?.name ?? "-", // Location (1,2,3… Multiple addition required)
                        item?.lanes?.[i]?.name ?? "-", // Lane name (1,2,3… Multiple addition required) (Lane Name = Cust.name#origin#destination#vehicleType#tonnage)
                        item?.origin ?? "-", // Origin
                        item?.destination ?? "-", // Destination
                        item?.lanes?.[i]?.vend_trip_rate ?? "-", // Rate
                        item?.lanes?.[i]?.vend_express_mode_rate_additional ?? "-", // Express mode rate additional
                        item?.lanes?.[i]?.vend_super_express_mode_rate_additional ?? "-", // Super express mode rate additional
                        item?.lanes?.[i]
                           ?.vend_multiple_loading_location_rate_additional ?? "-", // Multiple loading location rate additional
                        item?.lanes?.[i]
                           ?.vend_multiple_unloading_location_rate_additional ?? "-", // Multiple unloading location rate additional
                        item?.lanes?.[i]?.vend_detention_rate_additional ?? "-", // Detention Charge
                        item?.lanes?.[i]?.vend_loading_charges ?? "-", // Loading charges
                        item?.lanes?.[i]?.vend_unloading_charge ?? "-", // Unloading charge
                        item?.lanes?.[i]?.vend_miscellaneous_charges ?? "-", // Miscellaneous charges
                        item?.lanes?.[i]?.vend_miscellaneous_remarks ?? "-" // Miscellaneous Remarks
                     );
                     adhocVendorMasterId = item?.id;
                     adhocVendorMasterDataArr.push(arr);
                  }
               });

               // Combine headers and rows
               const sheetData = [
                  headers,
                  subheaders,
                  ...vendorMasterDataArr,
                  ...adhocVendorMasterDataArr,
               ];

               console.log({ report });
               const ws = XLSX.utils.aoa_to_sheet(sheetData);

               // Merging cells to create a header with sub-columns
               ws["!merges"] = [
                  { s: { r: 1, c: 9 }, e: { r: 1, c: 10 } }, // Merging cells for "Agreement Details"
               ];

               const wb = XLSX.utils.book_new();
               XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
               XLSX.writeFile(wb, "VENDOR_MASTER_REPORT.xlsx");
               dispatch(backdropLoadingAction(false));
               reportPopup.onFalse();
            },
         })
      );
   };

   const columns = [
      {
         name: "Vendor Name",
         selector: (row) => row.name,
         sortable: true,
      },
      {
         name: "Location",
         selector: (row) => row.location_master.name,
      },
      {
         name: "Action",
         width: "9rem",
         selector: (row) => {
            return (
               <div className="d-flex align-items-center">
                  <button
                     className="btn"
                     onClick={() => navigate("/vendor-master/edit/" + row.id)}
                  >
                     <BsPencilSquare
                        className="text-primary"
                        style={{ height: "1.5rem", width: "1.5rem" }}
                     />
                  </button>
                  <CustomToggleSwitch
                     checked={row?.is_active === "1"}
                     onChange={() => handleActiveInactive(row)}
                     isLoading={isActiveLoading.id === row?.id && isActiveLoading.status}
                  />
               </div>
            );
         },
      },
   ];

   const handleFilter = (e) => {
      const searchText = e.target.value.toLowerCase();
      const newData = vendorMasterList?.filter((item) => {
         return (
            item.name.toLowerCase().includes(searchText) ||
            item.location_master.name.toLowerCase().includes(searchText)
         );
      });
      setRecords(newData);
   };
   return (
      <div>
         <BodyHeader title="Vendor Master List" />

         <div className="px-3">
            <div className=" d-flex justify-content-between">
               <CustomInput
                  inputType="text"
                  placeholder="Search..."
                  id="search"
                  onChange={(e) => handleFilter(e)}
               />

               <DownloadReportButton
                  onDownloadReport={handleDownloadReport}
                  confirmPopup={reportPopup}
               />
            </div>
            <CustomTable columns={columns} data={records} />
         </div>
      </div>
   );
}
